import Countdown from '@/components/Countdown'
import {setI18l} from "@/helpers/veevalidate"
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: Countdown,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}